import Vue from "vue";
import App from "./App.vue";
import store from "./store/store.js";
import i18n from "./i18n";
import VueCookies from "vue-cookies";

Vue.config.productionTip = false;
Vue.use(VueCookies, { expire: "7d" });

new Vue({
  store,
  i18n,
  VueCookies,
  render: h => h(App)
}).$mount("#webdrive-vue-websales");
